import { axios } from '@/utils/request'

// 查询门店列表
export function getGoodsInfoList(goods_id,params) {
  return axios({
    url: `/info/${goods_id}`,
    method: 'get',
    params: params
  })
}

// 根据商品id和门店查询配置信息
export function getGoodsInfoConfig(goods_id,branch_id){
  return axios({
    url: `/info/${goods_id}/${branch_id}`,
    method: 'get',
  })
}


// 批量操作门店商品信息
export function updateInfos(list) {
  return axios({
    url: '/info',
    method: 'put',
    data: { info_sku: list }
  })
}
// 单个操作门店商品信息
export function saveInfoConfig(config) {
  return axios({
    url: '/stock/revise',
    method: 'post',
    data: config
  })
}